import { PROCESS_STATUS } from "constants/process";
import { isAboutToExpired as isAboutToExpiredFn } from "helpers/TimeFormatter";
import { KycInd } from "types/kyc";
import { IProcessStateReport } from "types/processStateReport";

type RenewalAddressConfirmationArgs = {
  currentKycStatus?: IProcessStateReport["currentStatus"];
  currentKycExpiresAt?: IProcessStateReport["expiresAt"];
  draftKycStatus?: KycInd["status"];
  poaCarriedOver?: boolean;
};

export const shouldShowRenewalAddressConfirmation = ({
  currentKycStatus,
  currentKycExpiresAt,
  draftKycStatus,
  poaCarriedOver,
}: RenewalAddressConfirmationArgs) => {
  if (!poaCarriedOver || draftKycStatus !== PROCESS_STATUS.draft || !currentKycStatus) {
    return false;
  }

  if (currentKycStatus === PROCESS_STATUS.expired || currentKycStatus === PROCESS_STATUS.outdated) {
    return true;
  }

  if (currentKycStatus !== PROCESS_STATUS.accepted || !currentKycExpiresAt) {
    return false;
  }

  return isAboutToExpiredFn(currentKycExpiresAt);
};
